import { Button, CircularProgress, Grid, LinearProgress, Paper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import IconAdd from "@material-ui/icons/Add";
import IconGames from "@material-ui/icons/Games";
import IconOpenWith from "@material-ui/icons/OpenWith";
import IconSave from "@material-ui/icons/Save";
import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

import IEventGalleryImage from "../../../../../types/IEventGalleryImage";
import ImageGalleryCard from "./ImageGalleryCard/ImageGalleryCard";

type IProps = {
    label: string;
    type: string;
    images?: IEventGalleryImage[];
    onUpload: (type: string, image: IEventGalleryImage, index: number) => void;
    onDelete: (type: string, index: number) => void;
    resetImage: (type: string, index: number, imageId: number) => void;
    onSave: (type: string) => void;
    onImageCreate: (type: string) => void;
    loadingGallery: boolean;
    onSort: (oldIndex: number, newIndex: number, type: string) => void;
    handleImagesSortSave: (type: string) => void;
};
const ImageGalleryTab = (props: IProps) => {
    const {
        images,
        onUpload,
        onDelete,
        resetImage,
        onSave,
        onImageCreate,
        onSort,
        handleImagesSortSave,
        label,
        type,
        loadingGallery,
    } = props;
    const [sortingActive, setSortingActive] = React.useState<boolean>(false);
    const toggleSortingAction = () => {
        if (sortingActive) {
            handleImagesSortSave(type);
        }

        setSortingActive(!sortingActive);
    };
    const SortableItem = SortableElement(({ value, index }: { value: any; index: any }) => (
        <ImageGalleryCard
            type={type}
            key={index + value.id}
            index={index}
            image={value}
            onChange={onUpload}
            onDelete={onDelete}
            onReset={resetImage}
            isSorting={sortingActive}
        />
    ));
    const SortableList = SortableContainer(({ items }: { items: IEventGalleryImage[] }) => {
        return (
            <Grid container direction="row" spacing={2} style={{ marginLeft: "-16px", marginRight: "-16px" }}>
                {items ? (
                    items.map((image: IEventGalleryImage, index) => (
                        <SortableItem value={image} index={index} key={image.id ? image.id + index + index : index} />
                    ))
                ) : (
                    <CircularProgress />
                )}
            </Grid>
        );
    });
    const onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
        onSort(oldIndex, newIndex, type);
    };
    return (
        <>
            {loadingGallery && <LinearProgress color={"primary"} style={{ marginBottom: "16px" }} />}

            <Paper variant="outlined" className="main-paper">
                <Typography variant="h2" className="main-header">
                    {label}
                </Typography>

                <Button
                    color="primary"
                    onClick={() => {
                        onSave(type);
                    }}
                    startIcon={<IconSave />}
                >
                    Bilder speichern
                </Button>

                <Button
                    color="secondary"
                    onClick={() => {
                        onImageCreate(type);
                    }}
                    startIcon={<IconAdd />}
                >
                    Bild hinzufügen
                </Button>
                <Button
                    color="secondary"
                    onClick={toggleSortingAction}
                    startIcon={sortingActive ? <IconOpenWith /> : <IconGames />}
                >
                    {sortingActive ? "Sortierung deaktivieren" : "Sortierung aktivieren"}
                </Button>
                {sortingActive && <SortableList items={images ? images : []} onSortEnd={onSortEnd} axis="xy" />}
                {!sortingActive && (
                    <Grid container direction="row" spacing={2} style={{ marginLeft: "-16px", marginRight: "-16px" }}>
                        {images?.map((image: IEventGalleryImage, index: number) => (
                            <ImageGalleryCard
                                type={type}
                                key={index}
                                index={index}
                                image={image}
                                onChange={onUpload}
                                onDelete={onDelete}
                                onReset={resetImage}
                            />
                        ))}
                    </Grid>
                )}
            </Paper>
        </>
    );
};

export default ImageGalleryTab;
